import LangsTopHeader from './Langs'
import MenuTopHeader from './Menu'
import style from './style.module.scss'

const TopHeader = ({ langs, menu }) => {
    return (
        <div className={style.top}>
            <LangsTopHeader langs={langs} />
            <div className={style.pipe} />
            <MenuTopHeader menu={menu} />
        </div>
    )
}

export default TopHeader
